"use strict";

export var ApplicationConstants = {
  NAVIGATE: 'NAVIGATE',
  ROUTER_LOADED: 'ROUTER_LOADED',
  LANG_LOADED: 'LANG_LOADED',
  LOAD_TABLE_FORM: 'LOAD_TABLE_FORM',
  DO_LOGOUT: 'DO_LOGOUT',
  CHANGE_THEME: 'CHANGE_THEME',
  CHANGE_THEME_DIRECTION: 'CHANGE_THEME_DIRECTION',
  SIDE_DRAWER_UPDATE_WIDTH: 'SIDE_DRAWER_UPDATE_WIDTH',
  SIDE_DRAWER_OPEN: 'SIDE_DRAWER_OPEN',
  SIDE_DRAWER_CLOSE: 'SIDE_DRAWER_CLOSE',
  SIDE_DRAWER_CHANGE_ANCHOR: 'SIDE_DRAWER_CHANGE_ANCHOR',
  CHANGE_DOCUMENT_TITLE: 'CHANGE_DOCUMENT_TITLE',
  SET_DOCUMENT_TITLE: 'SET_DOCUMENT_TITLE'
};